var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    _vm._l(_vm.data, function (d, i) {
      return _c("div", { key: i, style: _vm.indent }, [
        _c(
          "div",
          [
            _c(
              "b-checkbox",
              {
                attrs: { disabled: d.isDefault },
                model: {
                  value: d.value,
                  callback: function ($$v) {
                    _vm.$set(d, "value", $$v)
                  },
                  expression: "d.value",
                },
              },
              [_vm._v(" " + _vm._s(d.label) + " ")]
            ),
          ],
          1
        ),
        d.value === true && d.data !== null
          ? _c(
              "div",
              [
                _c("ReportFormColumn", {
                  attrs: { depth: _vm.depth + 1, data: d.data },
                }),
              ],
              1
            )
          : _vm._e(),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }